import { reveal } from './reveal';

export default function scrollReveal() {
  // Texts
  reveal(
    '.wp-block-column.col-text, .wp-block-group__content > p, .wp-block-group__content > h2, .footer__row, .header-top__container'
  );

  // Transform animation
  reveal(
    '.wp-block-columns-row, .wp-block-group__inner-container, .single-unit__row'
  );

  // Zoom out animation
  reveal(
    '.wp-block-image img, .single-post__header img, .news__post__image__inner'
  );

  //  Background animation
  reveal('.wp-block-group__background', {
    delay: 1800,
  });

  // H1 animations
  reveal('h1, .h1, h4, .h4', {
    delay: 1200,
  });

  // H4 animations
  reveal('h4, .h4');

  // H3 animations
  reveal('.wp-block-group__content > h3');

  // Vertical mask reveal
  reveal(
    '.wp-block-gallery figure, .wp-block-media-text__media, .wp-block-image'
  );

  // Menus
  reveal('.menus__menu', {
    interval: 350,
  });
}
